interface ProgressBarProps {
  score: number; // 누적 score
}

const ProgressBar = ({ score }: ProgressBarProps) => {
  const progressInCycle = score % 120;
  const percentage = (progressInCycle / 120) * 100;

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <span>{progressInCycle} / 120</span>
      </div>

      <div style={{
        width: "100%",
        height: "20px",
        backgroundColor: "#e0e0e0",
        borderRadius: "10px",
        overflow: "hidden",
      }}>
        <div style={{
          width: `${percentage}%`,
          height: "100%",
          backgroundColor: "#7c3697ff",
          transition: "width 0.4s ease",
        }} />
      </div>
    </div>
  );
};

export default ProgressBar;
